import { getItemFromCollection } from "directus/src/operations";

export async function fetchCompanyData({ companyId }) {
  try {
    const response = await getItemFromCollection("companies", companyId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
